import { useEffect, useRef } from 'react';

import {
  trackPageView,
  type PageData,
  type PageIdentifierType,
  type PageViewType,
} from '@crehana/analytics';
import { useMe } from '@crehana/web';

const usePageView = ({
  type,
  id,
  page,
  pageData,
}: {
  type: PageViewType;
  id?: number;
  page?: PageIdentifierType;
  pageData?: PageData;
}) => {
  const { me, loading, error } = useMe();
  const tracked = useRef<boolean>(false);

  useEffect(() => {
    if (!tracked.current && !loading && !error) {
      trackPageView({ type, id, page, user: me, pageData });
      tracked.current = true;
    }
  }, [me, loading, error]);
};

export default usePageView;
